import React, { Component } from 'react';
import SideMenuLand from '../../components/SideMenuLand/SideMenuLand';
import LandBg from '../../components/LandBg/LandBg';
import CardArcticicemin from '../../components/CardArcticicemin/CardArcticicemin';
import styled from 'styled-components';
import InfoSealevel from '../../components/InfoSealevel/InfoSealevel';
import InfoOceanwarming from '../../components/InfoOceanwarming/InfoOceanwarming';
import CarouselActions from '../../components/CarouselActions/CarouselActions';
import {Link} from 'react-router-dom';
import back from '../../assets/back.png';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;
const Navlink = styled(Link)`

    text-decoration:none;
    color:#ffffff;
  
`;

const Title = styled.h3`
  display:flex;
  font-family:roboto;
  font-size: 3rem;
  font-weight:300;
  color: #ffffff;
  margin: auto;
  letter-spacing: .6px;
  justify-content:center;
  margin:5px;
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
  margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;


const Backico = styled.img`
  margin-left:0px;
  justify-content:center;
  align-self:center;
  object-fit:contain;
  width:20px;
  height:auto;
  margin-right:5px;
`;

const Scaleup = styled.div`
  transform: scale(1);
  @media (max-width: 768px) {
    transform: scale(1.09);
  }
`;

const Spacer = styled.div`
  margin-top:70px;
`;

const Carouselheader = styled.h2`

  font-family:roboto;
  font-size: 2rem;
  font-weight:400;
  color: #ffffff;
  margin: 0.4em 0em 0.7em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;


class Land_Arcticicemin extends Component{


  render(){

    return(
      
        <body> 

          <SideMenuLand />
          <LandBg/>
          

          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree><Link to="/Land"><Backico src= {back}/></Link><Navlink to="/Land">Land </Navlink>/ Arctic Ice Minimum</Tree>
          </Contentwrapper>        
              <CardArcticicemin/>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
              <Impactwrapper><Link to= "/Oceans_Sea-Level"><InfoSealevel/></Link></Impactwrapper>
            <Impactwrapper><Link to= "/Oceans_Warming"><InfoOceanwarming/></Link></Impactwrapper>
            <Carouselheader><Navlink to="/Take-Action">TAKE ACTION</Navlink></Carouselheader>
              <Scaleup><CarouselActions/></Scaleup> 
              <Spacer/>
           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>


        </body>
      
      );

  } 
}

export default Land_Arcticicemin;